import * as React from 'react';
import { SymbolType, SystemType } from '@shared/types/tsk';
import { SYSTEM_COLORS } from '../utils/drawing';

import { getSymbolAcronym } from '../utils/symbolUtils';

interface TradeIconProps {
  type: SymbolType;
  system: SystemType;
  size?: number;
  className?: string;
}

const TradeIcon: React.FC<TradeIconProps> = ({ type, system, size = 32, className = "" }) => {
  const color = SYSTEM_COLORS[system];
  const acronym = getSymbolAcronym(type);


  const getFontSize = () => {
    const base = size * 0.4;
    if (acronym.length >= 3) return base * 0.75;
    return base;
  };

  // Check if we should render a geometric engineering symbol
  const isDirectional = [SymbolType.RISER, SymbolType.DROPPER].includes(type);

  const renderContent = () => {
    if (isDirectional) {
      // Use a fixed 100x100 coordinate system for the SVG to ensure perfect centering
      // regardless of parent border or size.
      if (type === SymbolType.RISER) {
        return (
          <svg width="100%" height="100%" viewBox="0 0 100 100" className="block">
            {/* Inner secondary ring */}
            <circle cx="50" cy="50" r="32" fill="none" stroke="white" strokeWidth="6" />
            {/* Center dot for riser */}
            <circle cx="50" cy="50" r="10" fill="white" />
          </svg>
        );
      }
      if (type === SymbolType.DROPPER) {
        return (
          <svg width="100%" height="100%" viewBox="0 0 100 100" className="block">
            {/* Inner secondary ring */}
            <circle cx="50" cy="50" r="32" fill="none" stroke="white" strokeWidth="6" />
            {/* X cross for dropper */}
            <line x1="32" y1="32" x2="68" y2="68" stroke="white" strokeWidth="6" strokeLinecap="round" />
            <line x1="68" y1="32" x2="32" y2="68" stroke="white" strokeWidth="6" strokeLinecap="round" />
          </svg>
        );
      }
    }

    return (
      <span
        className="font-black leading-none tracking-tighter relative z-10"
        style={{ fontSize: getFontSize() }}
      >
        {acronym}
      </span>
    );
  };

  return (
    <div
      className={`${className} relative flex items-center justify-center rounded-full border-2 border-white text-white shadow-lg select-none shrink-0 transition-transform duration-200`}
      style={{
        width: size,
        height: size,
        backgroundColor: color,
        boxShadow: `0 2px 8px rgba(0,0,0,0.4), inset 0 0 0 1px rgba(255,255,255,0.2)`
      }}
    >
      {renderContent()}
    </div>
  );
};

export default TradeIcon;